require './my-bases-setup'
require './base-position-setup'
require './bases-utilization-setup'
require './create-or-edit-bases-setup'